import React from 'react'
import createReactClass from 'create-react-class'
import './filtered-multi-select-dropdown.scss'
import Flag from './flag'

export default createReactClass({
  getDefaultProps () {
    return {
      defaultFilter: '',
      placeholder: 'type to filter',
      showFilter: true,
      textProp: 'text',
      valueProp: 'value',
      options: [],
      disabled: false,
      showButton: false,
    }
  },

  getInitialState () {
    let {defaultFilter, options} = this.props
    options = this.deepClone(options)
    return {
      // Filter text
      filter: defaultFilter,
      options,
      // options based on filter
      filteredOptions: this.filterOptions(defaultFilter, options),
    }
  },

  deepClone (options = []) {
    return options.map((option) => {
      return {...option}
    })
  },

  filterOptions (filter, options) {
    if (typeof filter === 'undefined') {
      filter = this.state.filter
    }
    if (typeof options === 'undefined') {
      options = this.state.options
    }
    filter = filter.toUpperCase()

    let {textProp} = this.props
    let filteredOptions = []

    for (let i = 0, l = options.length; i < l; i++) {
      if (!filter || options[i][textProp].toUpperCase().indexOf(filter) !== -1) {
        filteredOptions.push(options[i])
      }
    }

    return this.orderOptions(filteredOptions)
  },

  orderOptions (options) {
    options.sort((a, b) => {
      let aName = a[this.props.textProp].toUpperCase()
      let bName = b[this.props.textProp].toUpperCase()
      if (aName < bName) {
        return -1
      } else if (aName > bName) {
        return 1
      }
      return 0
    })
    let selectedOptionsIndex = []
    let selectedOptions = options.filter((option, index) => {
      if (option['selected']) {
        selectedOptionsIndex.push(index)
        return true
      }
      return false
    })
    for (let i = 0; i < options.length; i++) {
      if (selectedOptionsIndex.indexOf(i) === -1) {
        selectedOptions.push(options[i])
      }
    }
    return selectedOptions
  },

  onFilterChange (e) {
    let filter = e.target.value
    this.setState({
      filter,
      filteredOptions: this.filterOptions(filter),
    })
  },

  updateSelectedValues (e) {
    // no action while loading
    if (this.props.isLoading) {
      e.preventDefault()
      return
    }
    let el = e ? e.target : ''
    let options = [...this.state.options]
    let clickedValue = el.textContent || el.innerText
    let parenIndex = clickedValue.lastIndexOf('(')
    clickedValue = clickedValue.slice(0, parenIndex - 1)
    for (let i = 0; i < options.length; i++) {
      if (options[i][this.props.textProp] === clickedValue) {
        let selected = options[i]['selected']
        options[i]['selected'] = !selected
        break
      }
    }
    this.setState({options, filteredOptions: this.orderOptions(this.state.filteredOptions)}, () => {
      if (!this.props.showButton) {
        this.onAfterSelection()
      }
    })
  },

  renderListItem (option) {
    let selected = option['selected']
    let {valueProp, textProp} = this.props
    return (
      <li key={option[valueProp]} onClick={this.updateSelectedValues} className={selected ? 'selected' : ''}>
        <Flag code={option[valueProp]}/>
        <div className='option-text'>{`${option[textProp]} (${option[valueProp]})`}</div>
      </li>
    )
  },

  getSelectedOptionsValueArray () {
    let {options} = this.state
    return options.filter((option) => {
      return option['selected']
    }).map((selOption) => {
      return selOption[this.props.valueProp]
    })
  },

  onAfterSelection () {
    this.props.onAfterSelection(this.getSelectedOptionsValueArray())
  },

  render () {
    let {filter, filteredOptions} = this.state
    let {isLoading, placeholder, showFilter, showButton, countryLoader} = this.props
    let selectedOptions = this.getSelectedOptionsValueArray()
    let isButtonDisabled = countryLoader || isLoading || selectedOptions.length === 0
    return <div className='multi-select'>
      {showFilter && <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={filter}
        onChange={this.onFilterChange}
        onKeyPress={this.onFilterKeyPress}
        disabled={isLoading || countryLoader}
      />}
      <ul className="form-control multi-select-dropdown">
        {filteredOptions.map((option) => {
          return this.renderListItem(option)
        })}
      </ul>
      <div className='selected-text'>{`${selectedOptions.length} of ${this.props.options.length} countries selected`}</div>
      {showButton && <button
        className='search-criteria-button'
        onClick={this.onAfterSelection}
        disabled={isButtonDisabled}>
        {isLoading ? <i className="fa fa-spinner fa-spin"></i> : ''}Get Criteria</button>}
    </div>
  },
  componentWillReceiveProps (nextProps) {
    // update the state only when you receive the country list
    if (this.props.options.length === 0 && nextProps.options.length > 0) {
      let options = this.deepClone(nextProps.options)
      this.setState({
        filteredOptions: this.filterOptions(this.state.filter, options),
        options,
      })
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/filtered-multi-select-dropdown.js